@switch (hasProgress) {
    @case (true) {
        <adapt-progress-bar [percentageProgress]="keyResult.currentProgress"
                            [overrideText]="progressText"
                            [progressTooltip]="progressChangeTooltip"
                            colour="#6c757d"
                            backgroundColour="#e9ecef"></adapt-progress-bar>
    }
    <!-- colour and backgroundColour are var(--bs-gray-600) and var(--bs-gray-200) from _adapt-common-variables.scss -->
    @default {
        <div class="progress no-key-result-progress">This key result is yet to be scored.</div>
    }
}
